import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Caja from './pages/Caja';
import Historial from './pages/Historial';
import CambiarPassword from './pages/CambiarPassword';
import RutaProtegida from './components/RutaProtegida';
import { GradienteMarca } from './components/icons';

function App() {
  return (
    <BrowserRouter>
      <GradienteMarca />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/caja"
          element={
            <RutaProtegida>
              <Caja />
            </RutaProtegida>
          }
        />
        <Route
          path="/historial"
          element={
            <RutaProtegida>
              <Historial />
            </RutaProtegida>
          }
        />
        <Route
          path="/cambiar-password"
          element={
            <RutaProtegida>
              <CambiarPassword />
            </RutaProtegida>
          }
        />
        <Route path="*" element={<Navigate to="/caja" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
